<template>
    <div style="padding: 20px">
        <Tabs value="name1">
            <TabPane label="打印机设置" name="name1" style="padding: 20px">
                <Split v-model="split1" style="min-height: 500px;overflow: auto">
                    <div slot="left" class="demo-split-pane">
                       <h5>选择打印类型</h5>
<!--                        <Divider>58MM</Divider>-->
<!--                        <RadioGroup v-model="radios">-->
<!--                            <Alert class="alerts">-->
<!--                                <Radio label="6">58MM</Radio>-->
<!--                            </Alert>-->
<!--                        </RadioGroup>-->
                        <Divider>80MM</Divider>
                        <RadioGroup v-model="radios">
                            <Alert class="alerts">
                                <Radio label="4" :disabled = 'radios80'>80MM</Radio>
                            </Alert>
                        </RadioGroup>
                        <Divider>110MM</Divider>
                        <RadioGroup v-model="radios">
                            <Alert class="alerts">
                                <Radio label="5" :disabled = 'radios110'>110MM</Radio>
                            </Alert>
                        </RadioGroup>
                        <Divider>针式打印机</Divider>
                        <RadioGroup v-model="radios">
                            <Alert class="alerts">
                                <Radio label="1" :disabled = 'radioszhenshi'> 一等分</Radio>
                            </Alert>
                            <Alert class="alerts">
                                <Radio label="2" :disabled = 'radioszhenshi'> 二等分</Radio>
                            </Alert>
                            <Alert class="alerts">
                                <Radio label="3" :disabled = 'radioszhenshi'> 三等分</Radio>
                            </Alert>
                        </RadioGroup>
                    </div>
                    <div slot="right" class="demo-split-pane">
                        <h5>选择普通打印机</h5>
                        <RadioGroup v-model="ptRadios">
                            <Alert class="alerts">
                                <Radio label="0" :disabled = 'ptPrint'>普通打印机</Radio>
                            </Alert>
                        </RadioGroup>                        
                        <h5>选择云打印机</h5>
                        <Alert style="margin-top: 10px" v-if="CloudPringCodeLists.length==0">你还没有绑定云打印机，可以到APP中绑定设置.</Alert>
                        <Alert style="margin-top: 10px" v-if="isUseCloud">已选择打印机：<span :class="[ptPrint]" v-html="yuntext"></span></Alert>
                        <ul class="yunList">
                            <li v-for="(k,v) in CloudPringCodeLists" :key="v" @click="useCloud(k.printCode)">
                                <Icon type="ios-print-outline" size="60"/>
                                <p> {{k.printCode}} </p>
                            </li>
                        </ul>
                    </div>
                </Split>

            </TabPane>
        </Tabs>
    </div>
</template>
<script>
    export default {
        components: {},
        data() {
            return {
                cid: "",
                sid: "",
                radios: '',//打印类型
                ptRadios: '',//普通打印机
                split1: 0.4,
                CloudPringCodeLists: [],//云打印机集合
                ptPrint:false,//普通打印机
                radios80:false,
                radios110:false,//110打印机
                radioszhenshi:false,//1等分  2等分  3等分
                isUseCloud:false,//是否使用云打印
                yuntext:''//云打印号码
            }
        },
        watch: {
            radios: {
                deep: true,
                handler(val) {
                    localStorage.setItem('setpointSize', val)
                },
            },
            ptRadios: {
                deep: true,
                handler(val) {
                    if(1 != JSON.parse(sessionStorage.getItem('selectPrintFlag'))){
                        localStorage.setItem('yuntext', '');
                        this.isUseCloud= !this.isUseCloud;
                        this.yuntext = '';
                        //判断是选择云打印机，走普通打印机的监听不让起作用。
                        sessionStorage.setItem('selectPrintFlag', 2);
                    }else{
                        //判断是选择云打印机，走普通打印机的监听不让起作用。
                        sessionStorage.setItem('selectPrintFlag', 2);
                    }
                },
            },
        },
        created: function () {
            //DOM更新完之前请求数据
            this.cid = JSON.parse(localStorage.getItem('shop')).cid;
            this.sid = JSON.parse(localStorage.getItem('shop')).id;
            //选择的打印类型
            this.radios = localStorage.getItem('setpointSize');
            //选择的的打印机
            this.yuntext = localStorage.getItem('yuntext');
            this.ptRadios = localStorage.getItem('yuntext') != ''?'':'0';
            /**
             * 判断是否购买打印服务，0-80mm 1-110mm 2-针式打印机
             * 打印机向下兼容
             * ***/
            let printproductids = JSON.parse(localStorage.getItem("shop")).printproductids
            if(!printproductids){
                 this.radios80 = true
                 this.radios110 = true
                 this.radioszhenshi = true
            }else if(printproductids==0){
                this.radios80 = false
                this.radios110 = true
                this.radioszhenshi = true
            }else if(printproductids==1){
                this.radios80 = false
                this.radios110 = false
                this.radioszhenshi = true
            }else {
                this.radios80 = false
                this.radios110 = false
                this.radioszhenshi = false
            }
            //获取打印服务列表
            this.getCloudPringCodeLists()
        },
        methods: {
            getCloudPringCodeLists() {
                this.$Api.getCloudPringCodeLists({
                    cid: this.cid,
                    sid: this.sid,
                }).then(res => {
                    if (res.code == 200) {
                        this.CloudPringCodeLists = res.data
                        res.data.forEach(item=>{
                            if(item.printCode==this.yuntext){
                                this.isUseCloud=true
                            }else{
                                this.yuntext = "";
                            }
                        })
                    } else {
                        this.$Message.warning(res.msg);
                    }
                }).catch(err => {
                    this.$Message.warning(err.msg);
                });
            },
            useCloud(n){
                localStorage.setItem('yuntext', n);
                this.yuntext = n
                 this.isUseCloud=true
                 this.ptRadios = false;
                 this.ptPrint= false;
                 //判断是选择云打印机，走普通打印机的监听不让起作用。
                 sessionStorage.setItem('selectPrintFlag', 1);
            },
        }
    }
</script>
<style lang="scss" scoped>
    .server-title {
        display: inline-block;
        text-align: center;
        width: 88%
    }

    .logo {
        width: 50px;
        height: 50px;
        margin: auto;
    }

    .ivu-form-item {
        height: 30px;
    }

    .demo-split-pane {
        padding: 20px;
    }

    .alerts {
        float: left;
        margin-right: 10px;
        width: 150px;
    }

    .yunList {
        padding: 30px 20px 0;
        overflow: auto;

        li {
            float: left;
            width: 200px;
            line-height: 30px;
            cursor: pointer;
            text-align: center;
            position: relative;

            .selectThis {
                position: absolute;
                left: 50px;
                top: 0px;
                font-weight: bold;
            }
        }
    }
</style>